<template>
  <component :is="layout"></component>
</template>

<script>
import BaseLayout from './layouts/BaseLayout.vue';
import CenterLayout from './layouts/CenterLayout.vue';

export default {
  name: 'App',
  components: { BaseLayout, CenterLayout },
  computed: {
    layout() {
      return this.$store.state.route.meta.layout ? this.$store.state.route.meta.layout : 'base-layout';
    },
  },
};
</script>
